<div id="orders" class="page-layout simple right-sidebar" fxLayout="row">

    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div style="padding: 20px;" class="header primary" fxLayout="column" fxLayoutAlign="center center"
            fxLayoutGap="20px" fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">
            <span class="mat-display-1 my-0 my-sm-24 welcome-message"
                [@animate]="{value:'*',params:{x:'50px'}}">{{'WARN_NOTIFICATIONS' | translate}}
            </span>
        </div>
        <!-- / HEADER -->

        <div class="content-card" style="justify-content: space-between;">
            <div class="p-20">
                <mat-table class="orders-table mat-elevation-z8" style="border-radius: 10px 10px 0px 0px;" #table (matSortChange)="sortData($event)" matSortActive="createdAt"
                matSortDirection="desc"
                    [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}"  fusePerfectScrollbar>

                    <ng-container matColumnDef="title">
                        <mat-header-cell style="min-width: 150px !important;" *matHeaderCellDef class="table-header-form" mat-sort-header>
                            <div (click)="$event.stopPropagation()" class="w-100-p">
                                <mat-form-field class="w-100-p" appearance="fill">
                                    <mat-label>{{'TITLE'|translate}}</mat-label>
                                    <input matInput placeholder="{{'TITLE'|translate}}" [(ngModel)]="warnNotificationSearchModel?.title!.search_value"
                                        (keyup)="onSearchListen(warnNotificationSearchModel?.title!.search_field,warnNotificationSearchModel?.title!.search_value)">
                                </mat-form-field>
                            </div>
                        </mat-header-cell>
                        <mat-cell style="min-width: 150px !important;" *matCellDef="let element">
                            <p>{{element.title!=null?element.title:'---'}}</p>
                        </mat-cell>
                    </ng-container>


                    <ng-container matColumnDef="message">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-form">
                            <div (click)="$event.stopPropagation()" class="w-100-p">
                                <mat-form-field class="w-100-p" appearance="fill">
                                    <mat-label>{{'MESSAGE'|translate}}</mat-label>
                                    <input matInput placeholder="{{'MESSAGE'|translate}}" [(ngModel)]="warnNotificationSearchModel?.message!.search_value"
                                        (keyup)="onSearchListen(warnNotificationSearchModel?.message!.search_field,warnNotificationSearchModel?.message!.search_value)">
                                </mat-form-field>
                            </div>
                            </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p>
                                {{element.message!=null?element.message:'---'}}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-form">
                            <div (click)="$event.stopPropagation()" class="w-100-p">
                                <mat-form-field class="w-100-p" appearance="fill">
                                    <mat-label>{{'TYPE'|translate}}</mat-label>
                                    <mat-select class="w-100-p" [(ngModel)]="warnNotificationSearchModel?.type!.search_value"
                                        (selectionChange)="onSearchListen(warnNotificationSearchModel?.type!.search_field,warnNotificationSearchModel?.type!.search_value)">
                                        <mat-option [value]="''">
                                        </mat-option>
                                        <mat-option [value]="'theft'">
                                            {{'theft'|translate}}
                                        </mat-option>
                                        <mat-option [value]="'not-connection'">
                                            {{'not-connection'|translate}}
                                        </mat-option>
                                        <mat-option [value]="'low-battery'">
                                            {{'low-battery'|translate}}
                                        </mat-option>
                                        <mat-option [value]="'low-solar'">
                                            {{'low-solar'|translate}}
                                        </mat-option>
                                        <mat-option [value]="'err-solar'">
                                            {{'err-solar'|translate}}
                                        </mat-option>
                                        <mat-option [value]="'hot-cpu'">
                                            {{'hot-cpu'|translate}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p>
                                {{element.type!=null?(element.type |translate):'---'}}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="IsLocationCorrect">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-form">
                            <div (click)="$event.stopPropagation()" class="w-100-p">
                                <mat-form-field class="w-100-p" appearance="fill">
                                    <mat-label>{{"LOCATION_CORRECT" |translate}}</mat-label>
                                    <mat-select class="w-100-p" [(ngModel)]="warnNotificationSearchModel?.isLocationCorrect!.search_value"
                                        (selectionChange)="onSearchListen(warnNotificationSearchModel?.isLocationCorrect!.search_field,warnNotificationSearchModel?.isLocationCorrect!.search_value)">
                                        <mat-option [value]="''">
                                        </mat-option>
                                        <mat-option [value]="true">
                                            {{'YES'|translate}}
                                        </mat-option>
                                        <mat-option [value]="false">
                                            {{'NO'|translate}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p>
                                {{element.isLocationCorrect==true?('YES'|translate):'NO'|translate}}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="deviceID">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-form">
                            <div (click)="$event.stopPropagation()" class="w-100-p">
                                <mat-form-field class="w-100-p" appearance="fill">
                                    <mat-label>{{'DEVICE'|translate}}</mat-label>
                                    <input matInput placeholder="{{'DEVICE'|translate}}" [(ngModel)]="warnNotificationSearchModel?.deviceId!.search_value"
                                        (keyup)="onSearchListen(warnNotificationSearchModel?.deviceId!.search_field,warnNotificationSearchModel?.deviceId!.search_value)">
                                </mat-form-field>
                            </div>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p>
                                {{element.deviceId!=null?element.deviceId:'---'}}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="createdAt">
                        <mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-form">
                            <div (click)="$event.stopPropagation()" class="w-100-p">
                                <mat-form-field class="w-100-p" appearance="fill">
                                    <mat-label>{{'CREATED_AT'|translate}}</mat-label>
                                    <input matInput [matDatepicker]="datepicker" (dateChange)="onSearchListen(warnNotificationSearchModel?.createdAt!.search_field,warnNotificationSearchModel?.createdAt!.search_value)"  [(ngModel)]="warnNotificationSearchModel?.createdAt!.search_value">
                                    <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
                                    <mat-datepicker #datepicker>
                                    </mat-datepicker>
                                  </mat-form-field>
                            </div>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <p>
                                {{element.createdAt!=null?(element.createdAt | date:'dd/MM/y HH:mm'):'---'}}
                            </p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="setting">
                        <mat-header-cell *matHeaderCellDef>{{'SETTINGS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="onLastStatusClick(element)">
                                    <mat-icon>access_time</mat-icon>
                                    <span>{{'LAST_STATUS'|translate}}</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let element; columns: displayedColumns;"
                        class="order" matRipple>
                    </mat-row>
                </mat-table>

                <mat-paginator #paginator [length]="paginator.length" (page)="pageChange($event)" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>